import "./Checkout.module.css";
import EstateHeader from "@/reusable_sections/Header";
import CheckoutContent from "./sections/CheckoutContent";
import EstateFooter from "@/reusable_sections/Footer";
export default function CheckoutPage() {
  return <div>
      <EstateHeader />
      <CheckoutContent />
      <EstateFooter />
    </div>;
}